<div class="router-bar">
  <div class="route-button">
    <button mat-button [routerLink]="['/orders/list']">Orders</button>
  </div>
  <div class="route-button">
    <button mat-button [routerLink]="['/orders/vendors']">Vendors</button>
  </div>
  <div class="route-button current-route">
    <button mat-button [routerLink]="['/orders/materials']">Materials</button>
  </div>
</div>

<p-table #mt [columns]="materialsCols" [value]="materials" [paginator]="true" [rows]="matPerPage"
         [totalRecords]="totalElems" [lazy]="true" (onLazyLoad)="loadMaterials($event)"
         (onEditInit)="startEdit($event)">
  <ng-template pTemplate="caption">
    <div class="filter-select-block" [ngClass]="{'all-vendors': selectedVendors.length === vendors.length}">
      <p-multiSelect [defaultLabel]="'Vendors'" [selectedItemsLabel]="vendorFiltersLabel" [options]="vendors"
                     [(ngModel)]="selectedVendors" [showToggleAll]="true" (onChange)="changeFilter()"
                     [filter]="true" [maxSelectedLabels]="1">
      </p-multiSelect>
    </div>
    <div class="filter-select-block" [ngClass]="{'all-types': selectedTypes.length === types.length}">
      <p-multiSelect [defaultLabel]="'Types'" [selectedItemsLabel]="typeFiltersLabel" [options]="types"
                     [(ngModel)]="selectedTypes" [showToggleAll]="true" (onChange)="changeFilter()"
                     [filter]="true" [maxSelectedLabels]="1">
      </p-multiSelect>
    </div>

    <div class="search-header">
        <span class="p-input-icon-right">
            <i class="pi pi-times cross-icon" (click)="deleteQuery()" *ngIf="searchQuery?.length > 0"></i>
            <input class="global-filter-input" type="text" pInputText BlockLateralArrowNavigation size="50"
                   placeholder="Search in Materials"
                   (input)="topSearchBar()" style="width:auto" [(ngModel)]="searchQuery">
        </span>
      <i class="pi pi-search search-icon"></i>
    </div>
    <div class="space-block">

    </div>
    <div class="create-material-button-block">
      <button mat-button class="create-material-button" (click)="createMaterial()">
        <span *ngIf="!createMaterialLoading">Create Material</span>
        <lib-mini-progress-spinner *ngIf="createMaterialLoading"></lib-mini-progress-spinner>
      </button>
    </div>

    <div class="filter-block">
      <app-materials-filter-button [allMaterialsCols]="allMaterialsCols" (colsEdited)="colsEdited()">
      </app-materials-filter-button>
    </div>
  </ng-template>
  <ng-template pTemplate="header" let-columns>
    <tr>
      <th *ngFor="let col of columns" class="material-header">
        {{col?.header}}
      </th>
      <th class="material-header">
        Delete
      </th>
    </tr>
  </ng-template>

  <ng-template pTemplate="body" let-rowData let-colData="columns">
    <tr [pSelectableRow]="rowData">
      <td pEditableColumn class="editable-cell name-cell" *ngIf="materialsShowsMap.get('name')">
        <p-cellEditor>
          <ng-template pTemplate="input">
            <input pInputText BlockLateralArrowNavigation type="string" class="material-input-text"
                   [(ngModel)]="rowData.name"
                   (ngModelChange)="editMaterial(rowData)">
          </ng-template>
          <ng-template pTemplate="output">
            {{rowData.name}}
          </ng-template>
        </p-cellEditor>
      </td>
      <td pEditableColumn class="editable-cell desc-cell" *ngIf="materialsShowsMap.get('description')">
        <p-cellEditor>
          <ng-template pTemplate="input">
            <input pInputText BlockLateralArrowNavigation type="string" class="material-input-text"
                   [(ngModel)]="rowData.description"
                   (ngModelChange)="editMaterial(rowData)">
          </ng-template>
          <ng-template pTemplate="output">
            {{rowData.description}}
          </ng-template>
        </p-cellEditor>
      </td>
      <td pEditableColumn class="editable-cell stock-cell" *ngIf="materialsShowsMap.get('bandingRollLength')">
        <p-cellEditor>
          <ng-template pTemplate="input">
            <input pInputText BlockLateralArrowNavigation type="string" class="material-input-text"
                   [(ngModel)]="rowData.bandingRollLength"
                   (ngModelChange)="editMaterial(rowData)">
          </ng-template>
          <ng-template pTemplate="output">
            {{rowData.bandingRollLength}}
          </ng-template>
        </p-cellEditor>
      </td>
      <td class="editable-cell vend-cell" *ngIf="materialsShowsMap.get('defaultVendor.name')">
        <p-dropdown [options]="vendors" [(ngModel)]="rowData.defaultVendor"
                    (ngModelChange)="editMaterial(rowData)" placeholder="No Vendor">
        </p-dropdown>
      </td>
      <td class="editable-cell type-cell" *ngIf="materialsShowsMap.get('type.name')">
        <p-dropdown [options]="types" [(ngModel)]="rowData.type" (ngModelChange)="editMaterial(rowData)"
                    placeholder="No Type">
        </p-dropdown>
      </td>
      <td class="editable-cell unit-cell" *ngIf="materialsShowsMap.get('unitOfIssue.name')">
        <p-dropdown [options]="units" [(ngModel)]="rowData.unitOfIssue" (ngModelChange)="editMaterial(rowData)"
                    placeholder="No Unit">
        </p-dropdown>
      </td>
      <td pEditableColumn class="editable-cell is-stock-cell" *ngIf="materialsShowsMap.get('isStock')">
        <p-cellEditor>
          <ng-template pTemplate="input">
            <p-checkbox class="isstock-checkbox" [(ngModel)]="rowData.isStock" [binary]="true"
                        (ngModelChange)="editMaterial(rowData)">
            </p-checkbox>
          </ng-template>
          <ng-template pTemplate="output">
            <p-checkbox class="isstock-checkbox" [(ngModel)]="rowData.isStock" [binary]="true"
                        (ngModelChange)="editMaterial(rowData)">
            </p-checkbox>
          </ng-template>
        </p-cellEditor>
      </td>
      <td pEditableColumn class="editable-cell stock-cell" *ngIf="materialsShowsMap.get('minStockQty')">
        <p-cellEditor>
          <ng-template pTemplate="input">
            <input pInputText BlockLateralArrowNavigation type="tel" class="material-input-text"
                   [(ngModel)]="rowData.minStockQty"
                   (ngModelChange)="editMaterial(rowData)">
          </ng-template>
          <ng-template pTemplate="output">
            {{rowData.minStockQty}}
          </ng-template>
        </p-cellEditor>
      </td>
      <td pEditableColumn class="editable-cell stock-cell" *ngIf="materialsShowsMap.get('inStockCount')">
        <p-cellEditor>
          <ng-template pTemplate="input">
            <input pInputText BlockLateralArrowNavigation type="tel" class="material-input-text"
                   [(ngModel)]="rowData.inStockCount"
                   (ngModelChange)="editMaterial(rowData)">
          </ng-template>
          <ng-template pTemplate="output">
            {{rowData.inStockCount}}
          </ng-template>
        </p-cellEditor>
      </td>
      <td pEditableColumn class="editable-cell stock-cell" *ngIf="materialsShowsMap.get('reorderQty')">
        <p-cellEditor>
          <ng-template pTemplate="input">
            <input pInputText BlockLateralArrowNavigation type="tel" class="material-input-text"
                   [(ngModel)]="rowData.reorderQty"
                   (ngModelChange)="editMaterial(rowData)">
          </ng-template>
          <ng-template pTemplate="output">
            {{rowData.reorderQty}}
          </ng-template>
        </p-cellEditor>
      </td>
      <td pEditableColumn class="editable-cell waste-cell" *ngIf="materialsShowsMap.get('waste')">
        <p-cellEditor>
          <ng-template pTemplate="input">
            <input pInputText BlockLateralArrowNavigation type="tel" class="material-input-text"
                   [(ngModel)]="rowData.waste"
                   (ngModelChange)="editMaterial(rowData)">
          </ng-template>
          <ng-template pTemplate="output">
            {{rowData.waste}}%
          </ng-template>
        </p-cellEditor>
      </td>
      <td pEditableColumn class="editable-cell waste-cell" *ngIf="materialsShowsMap.get('defaultMarkup')">
        <p-cellEditor>
          <ng-template pTemplate="input">
            <input pInputText BlockLateralArrowNavigation type="tel" class="material-input-text"
                   [(ngModel)]="rowData.defaultMarkup"
                   (ngModelChange)="editMaterial(rowData)">
          </ng-template>
          <ng-template pTemplate="output">
            {{rowData.defaultMarkup}}%
          </ng-template>
        </p-cellEditor>
      </td>
      <td pEditableColumn class="editable-cell waste-cell" *ngIf="materialsShowsMap.get('defaultTaxRate')">
        <p-cellEditor>
          <ng-template pTemplate="input">
            <input pInputText BlockLateralArrowNavigation type="tel" class="material-input-text"
                   [(ngModel)]="rowData.defaultTaxRate"
                   (ngModelChange)="editMaterial(rowData)">
          </ng-template>
          <ng-template pTemplate="output">
            {{rowData.defaultTaxRate}}%
          </ng-template>
        </p-cellEditor>
      </td>
      <td pEditableColumn class="editable-cell cost-cell" *ngIf="materialsShowsMap.get('defaultCost')">
        <p-cellEditor>
          <ng-template pTemplate="input">
            <input pInputText BlockLateralArrowNavigation type="tel" class="material-input-text"
                   [(ngModel)]="rowData.defaultCost"
                   (ngModelChange)="editMaterial(rowData)">
          </ng-template>
          <ng-template pTemplate="output">
            {{rowData.defaultCost}}$
          </ng-template>
        </p-cellEditor>
      </td>
      <td pEditableColumn class="editable-cell cost-cell" *ngIf="materialsShowsMap.get('sellPrice')">
        <p-cellEditor>
          <ng-template pTemplate="input">
            <input pInputText BlockLateralArrowNavigation type="tel" class="material-input-text"
                   [(ngModel)]="rowData.sellPrice"
                   (ngModelChange)="editMaterial(rowData)">
          </ng-template>
          <ng-template pTemplate="output">
            {{rowData.sellPrice}}$
          </ng-template>
        </p-cellEditor>
      </td>
      <td class="editable-cell delete-cell">
        <mat-icon (click)="deleteMaterial(rowData)">delete</mat-icon>
<!--        <mat-icon (click)="deleteMaterial(rowData)">delete</mat-icon>-->
      </td>
    </tr>
  </ng-template>
  <!--	<ng-template pTemplate="summary">
    <div class="customers-counter">
      {{footerString}}
    </div>
  </ng-template>-->

  <ng-template pTemplate="footer">
    <div class="spinner-block" *ngIf="loadings.length > 0">
      <lib-progress-spinner></lib-progress-spinner>
    </div>
  </ng-template>
</p-table>
